module.exports = __webpack_public_path__ + "img/d11.6cb5dfd6.png";